import React from "react";
import "./PoliciesStyling.css";
import logo from "../../logo.png";
import { useNavigate } from "react-router-dom";

const RefundPolicy = () => {
  const navigate = useNavigate();

  return (
    <main className="policy-page">
      <header className="policy-topbar">
        <button
          className="policy-back-btn"
          onClick={() => navigate(-1)}
          type="button"
        >
          Back
        </button>

        <div className="policy-brand">
          <img src={logo} alt="Kairos" className="policy-logo" />
          <span className="policy-brand-name">Kairos</span>
        </div>
      </header>

      <section className="policy-glass">
        <h1 className="policy-title">Refund Policy</h1>
        <p className="policy-updated">Last updated: February 5, 2026</p>

        <div className="policy-section">
          <h2>1. Overview</h2>
          <p>
            This Refund Policy explains when refunds may be available for Kairos
            subscriptions, credits, and related purchases. If you have questions,
            contact <strong>support@yourdomain.com</strong>.
          </p>
        </div>

        <div className="policy-section">
          <h2>2. Subscription refunds</h2>
          <ul>
            <li>
              Subscription fees are generally <strong>non-refundable</strong> once a
              billing cycle has started, unless required by law.
            </li>
            <li>
              If you cancel, your plan remains active until the end of your current
              billing period (no partial refunds for unused time).
            </li>
            <li>
              If you were billed in error (duplicate charge, wrong plan, etc.), we
              will review and may issue a correction or refund.
            </li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>3. Credits and usage-based purchases</h2>
          <ul>
            <li>
              AI credits and usage-based purchases are typically{" "}
              <strong>non-refundable</strong> once delivered to your account.
            </li>
            <li>
              If credits were purchased due to a technical issue or duplicate charge,
              we will investigate and may refund or re-credit your account.
            </li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>4. Publishing, domains, and third-party services</h2>
          <p>
            Some features may involve third-party services (for example: payment
            processors, domain registrars, email providers, or hosting add-ons). Any
            third-party fees may be subject to their own refund rules and may not be
            refundable by Kairos.
          </p>
        </div>

        <div className="policy-section">
          <h2>5. When refunds may be granted</h2>
          <ul>
            <li>Duplicate charges</li>
            <li>Billing mistakes (wrong plan or unintended renewal)</li>
            <li>Service outages or severe faults (case-by-case review)</li>
            <li>Legal requirement in your jurisdiction</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>6. Refund request process</h2>
          <ul>
            <li>
              Contact <strong>support@yourdomain.com</strong> with your account email
              and details of the issue.
            </li>
            <li>
              Include relevant proof (invoice/receipt date, charge amount, screenshots if needed).
            </li>
            <li>
              If approved, refunds are issued to the original payment method where possible.
            </li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>7. Chargebacks</h2>
          <p>
            If you initiate a chargeback, we may suspend access while we investigate.
            Please contact support first so we can resolve billing issues faster.
          </p>
        </div>

        <div className="policy-section">
          <h2>8. Policy updates</h2>
          <p>
            We may update this Refund Policy from time to time. Material changes will
            be communicated in reasonable ways, and the “Last updated” date will be revised.
          </p>
        </div>
      </section>

      <footer className="policy-footer">
        <p>© 2026 Kairos AI. All rights reserved.</p>
      </footer>
    </main>
  );
};

export default RefundPolicy;
